import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { authServices } from '../authServices'
import { VerifyCodeDTO, CheckCodeSentToEmailPayload } from '../authTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useCheckCodeSentToEmail = (
  options?: IOptionsUseMutation<VerifyCodeDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<VerifyCodeDTO, ErrorDetail, CheckCodeSentToEmailPayload>({
    mutationFn: authServices.checkCodeSentToEmail,
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
